import { makeStyles, Typography as MuiTypography } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    color: ({ themeColor }) => theme.colors[themeColor] ?? themeColor ?? theme.colors.dark,
    fontWeight: ({ fontWeight }) => fontWeight,
  },
  dropdown: theme.typography.dropdown,
}));

const Typography = React.forwardRef((props, ref) => {
  const { className, variant, themeColor, fontWeight, ...otherProps } = props;
  const classes = useStyles({ themeColor, fontWeight });

  return (
    <MuiTypography
      {...otherProps}
      variant={variant === 'dropdown' ? undefined : variant}
      className={classnames(
        classes.root,
        { [classes.dropdown]: variant === 'dropdown' },
        className
      )}
      ref={ref}
    />
  );
});

Typography.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    'button',
    'overline',
    'srOnly',
    'inherit',
    // This is not included in MUI's default variant
    'dropdown',
  ]),
  // Color applied to the root element
  // Could be any of the theme colors
  themeColor: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Typography.defaultProps = {
  className: undefined,
  variant: 'body1',
  themeColor: undefined,
  fontWeight: undefined,
};

export default Typography;
